import React from 'react';

const TabNavigation = ({ activeTab, onTabChange, styles }) => {
  const tabs = [
    { id: 'all', label: 'All Equipment' },
    { id: 'overdue', label: 'Overdue Maintenance' },
    { id: 'certificates', label: 'Certificates' },
  ];

  return (
    <div className={`flex border-b ${styles.borderColor} mb-6`}>
      {tabs.map(tab => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`
            px-6 py-3
            ${styles.tabLabelSize || styles.fontSize}
            ${styles.tracking || ''}
            transition
            ${activeTab === tab.id
              ? `border-b-2 border-blue-600 ${styles.tabActiveWeight || styles.tabLabelWeight || styles.fontWeight} ${styles.tabActiveColor || 'text-blue-600'}`
              : `${styles.tabLabelWeight || styles.fontWeight} ${styles.tabLabelColor || 'text-gray-500'} ${styles.tabInactiveHover || 'hover:text-gray-700'}`
            }
          `}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default TabNavigation;
